import {Route, Routes} from 'react-router-dom';

import {pageRoutes} from '.';
import ProtectedRoute from './ProtectedRoute';
import Login from '../pages/authentication/Login';
import ForgotPassword from '../pages/authentication/ForgotPassword';
import ResetPassword from '../pages/authentication/ResetPassword';
import useAuthStore from '../store/useAuthStore';
import AppLayout from '../layout/AppLayout';

const AppRoutes = () => {
  const isLogin = useAuthStore((state) => state.isLogin);
  return (
    <Routes>
      {!isLogin && (
        <>
          <Route path={pageRoutes.login} element={<Login />} />
          <Route
            path={pageRoutes.forgotPassword}
            element={<ForgotPassword />}
          />
          <Route path={pageRoutes.resetPassword} element={<ResetPassword />} />
        </>
      )}
      <Route
        path="*"
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
